import React, { Component } from 'react';
import { flowRight as compose } from 'lodash';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import { formValueSelector, change } from 'redux-form';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';

import messages from '../../../../locale/jsonMessages';
import { photosShow } from '../../../../helpers/photosShow';

import { getImageLoader } from '../../../../actions/siteadmin/ImageLoader/imageLoader';
import { IMAGE_LOADER1_START, IMAGE_LOADER1_SUCCESS } from '../../../../constants/index';

// Asset
import ImageUploadComponent from '../../ImageUploadComponent/ImageUploadComponent';
import CommonImageDisplay from '../../CommonImageDisplay/CommomImageDisplay'
import { homebanneruploadDir } from '../../../../config';
import { demoRestriction } from '../../../../helpers/DemoRestriction/demoRestriction';

import cs from '../../../../components/commonStyle.css';
import s from './Uploader.css';
class Uploader extends React.Component {
  static defaultProps = {
    loader: false
  };

  success = async (file, fromServer) => {
    const { change, getImageLoader, demoRestriction } = this.props;
    let fileName = fromServer.file.filename;
    const isRestrict = await demoRestriction({});
    if (isRestrict) return;
    await getImageLoader(IMAGE_LOADER1_START, true);
    await change('FindYourVehicleForm', 'image', fileName);
    await getImageLoader(IMAGE_LOADER1_SUCCESS, false)
  }

  render() {
    const { image, loader } = this.props;
    const { formatMessage } = this.props.intl;
    let path = photosShow(homebanneruploadDir);

    return (
      <div>
        <CommonImageDisplay
          loader={loader}
          image={image && path + image}
          isDefaultPic={image ? false : true}
        />

        <ImageUploadComponent
          defaultMessage={formatMessage(messages.clickHeretoUploadImage)}
          componentConfig={{
            iconFiletypes: ['.jpg', '.png'],
            multiple: false,
            showFiletypeIcon: false,
            postUrl: '/uploadHomeBanner'
          }}
          loaderName={'loader'}
          success={this.success}
          className={cs.spaceTop3}
        />
      </div>
    );
  }
}
const selector = formValueSelector('FindYourVehicleForm');

const mapState = (state) => ({
  loader: state.loader.loader,
  image: selector(state, 'image')
});

const mapDispatch = {
  change,
  getImageLoader,
  demoRestriction
};

export default injectIntl(withStyles(s, cs)(connect(mapState, mapDispatch)(Uploader)));